import { Component, OnInit, ChangeDetectorRef } from '@angular/core';

import { Inspection } from '../../shared/models/index';
import { PluginComponent } from '../plugin.component';
import { BasePlugin } from '../base-plugin.component';

@Component({
    templateUrl: './recommendedparts.component.html',
    standalone: false
})
export class RecommendedPartsPluginComponent extends BasePlugin implements OnInit {
  public plugin: any;
  public inspection: Inspection;

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [this.inspectionsRoute, this.inspection.id, 'plugins', this.plugin.id, 'recommendedparts', 'edit'];
  }
}

PluginComponent.plugins['recommendedparts'] = RecommendedPartsPluginComponent;
